{
  "colorInputLabel": "{label}, {channelLabel}",
  "colorNameAndValue": "{name}: {value}",
  "colorPicker": "Odabir boje",
  "twoDimensionalSlider": "2D klizač",
  "colorSwatch": "color swatch",
  "transparent": "transparent"
}
